import script from "./defaultStyleMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./defaultStyleMain.vue?vue&type=script&lang=ts&setup=true"

import "./defaultStyleMain.vue?vue&type=style&index=0&id=708a2368&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-708a2368"]])

export default __exports__